module.exports = __webpack_public_path__ + "src/img/whattodo2.jpg?14ab4de3b1344c2fda4001e4a9d88167";


//////////////////
// WEBPACK FOOTER
// ./src/img/whattodo2.jpg
// module id = 213
// module chunks = 0